import { render, staticRenderFns } from "./LargeCard.vue?vue&type=template&id=2295fdee&scoped=true&"
import script from "./LargeCard.vue?vue&type=script&lang=js&"
export * from "./LargeCard.vue?vue&type=script&lang=js&"
import style0 from "./LargeCard.vue?vue&type=style&index=0&id=2295fdee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295fdee",
  null
  
)

export default component.exports